import config from '~/config';
import http from './http';

export const getUseofProperties = async () => {
    try {
        const results = await http.get(`${config.urls.base}/useOfProperty`);
        if (results.errored) {
            throw new Error(results.error);
        }

        return results;

    } catch (err) {
        console.error(err);
        return [];
    }
};

export default {
    getUseofProperties
};